<div class="container pt-3">
  <div class="row justify-content-center">
    <div class="col-12 col-xl-10 text-center">
      <!-- <h3 *ngIf="!title" class="pb-3">{{ 'Question?' | translate }} </h3> -->
      <h3 *ngIf="title" class="pb-3">{{ title }} </h3>
      <p *ngIf="!description" class="pb-3">{{ 'You need help with your order or can not find the right Ticket?' | translate }}
        <br>{{ phone }} {{ "// Every day from 10am to 6pm" | translate }}</p>
      <p *ngIf="description" class="pb-3">{{ description }}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-5 col-xl-4">
      <div class="button button-right button-black float-right">
        <button (click)="navigateToContactForm()"></button>
        <span class="bar"></span>
        <label class="contact-us-label">{{ 'To contact' | translate }}</label>
      </div>
    </div>
  </div>
</div>
